import { createFileRoute } from "@tanstack/react-router";
import { DocumentReader } from "~/features/documents/document-reader";

export const Route = createFileRoute("/_app/documents/user-manual")({
  component: () => <DocumentReader id="user-manual" />,
});
